import { css } from "@emotion/css";

import { calculateSubrangePercentage } from "./utils";
import { Config } from "../RangeGraph";
interface Props {
  config: Config;
}

const getClassName = (
  index: number,
  count: number,
  backgroundColor: string,
  percentage?: number
) => {
  return css({
    width: `${percentage}%`,
    backgroundColor,
    borderTopLeftRadius: index === 0 ? "var(--border-radius-half)" : undefined,
    borderBottomLeftRadius:
      index === 0 ? "var(--border-radius-half)" : undefined,
    borderTopRightRadius:
      count === index + 1 ? "var(--border-radius-half)" : undefined,
    borderBottomRightRadius:
      count === index + 1 ? "var(--border-radius-half)" : undefined,
  });
};

export function Scale(props: Props) {
  const { config } = props;
  const ranges = config.ranges.map((range) => {
    return {
      ...range,
      percentage: calculateSubrangePercentage(
        range.min,
        range.max,
        config.minRange,
        config.maxRange
      ),
    };
  });
  return (
    <div className={css(styles.container)}>
      {ranges.map((range, index) => (
        <div
          key={index}
          className={getClassName(
            index,
            props.config.ranges.length,
            range.backgroundColor,
            range.percentage
          )}
        />
      ))}
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    "> div": {
      height: "24px",
    },
  }),
};
